import { Box, Tab, Tabs } from '@mui/material';

type FavoritesTabsProps = {
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
  tabs: { label: string }[];
};

export function FavoritesTabs({
  selectedTab,
  setSelectedTab,
  tabs,
}: FavoritesTabsProps) {
  function handleTabChange(newValue: number) {
    setSelectedTab(newValue);
    //setSelectedChartInfo(items[newValue]);
  }

  return (
    <Tabs
      variant="scrollable"
      allowScrollButtonsMobile
      scrollButtons="auto"
      value={selectedTab}
      onChange={(_, value) => handleTabChange(value)}
      TabIndicatorProps={{
        children: <Box component="span" className="MuiTabs-indicatorSpan" />,
      }}
      sx={(theme) => ({
        '& .MuiTabs-flexContainer': {
          borderBottom: `2px solid ${theme.palette.grey[200]}`,
        },
        '& .MuiTabs-indicator': {
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: 'transparent',
        },
        '& .MuiTabs-indicatorSpan': {
          maxWidth: 200,
          width: '100%',
          backgroundColor: theme.palette.primary.main,
        },
        '& .MuiButtonBase-root': {
          minWidth: 0,
          paddingBottom: 0,
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          pb: 0,
          '&.Mui-selected': {
            backgroundColor: 'transparent',
          },
        },
        [theme.breakpoints.down('md')]: {
          padding: 0,
          mt: 6,
          '& .MuiTabs-indicatorSpan': {
            maxWidth: 80,
          },
        },
        [theme.breakpoints.down('lg')]: {
          '& .MuiButtonBase-root': {
            flexDirection: 'column',
          },
        },
      })}>
      {tabs.map((item) => (
        <Tab
          key={item.label}
          label={item.label}
          sx={{ textTransform: 'none', fontSize: 16, fontWeight: 500 }}
        />
      ))}
    </Tabs>
  );
}
